module.exports = __webpack_public_path__ + "img/plan-02.5573d7c7.png";